import React, { useState } from "react";
import superagent from "superagent";
import PropTypes from "prop-types";
import { Button, Dropdown, Form, Message } from "semantic-ui-react";
import { UPGRADE_TYPES } from "../../../server/constants";
import { AUTH_API_URL } from "_constants";
import { SingularSearch as ResellerSearch } from "../../forms/resellerSearch";
import BaseInputField from "_forms/baseInput";

const UpgradeLicense = ({
  license,
  onCancel,
  onUpgradeLicense,
}) => {
  const [upgradeType, setUpgradeType] = useState(UPGRADE_TYPES.USER);
  const [resellerId, setResellerId] = useState(null);
  const [resellerInvoiceNumber, setResellerInvoiceNumber] = useState(null);
  const [upgradeLoading, setUpgradeLoading] = useState(false);
  const [formError, setFormError] = useState(null);

  const handleUpgrade = () => {
    if (window.confirm("Upgrade this license?")) {
      setFormError(null);
      setUpgradeLoading(true);

      if (upgradeType === UPGRADE_TYPES.RESELLER && !resellerId) {
        setUpgradeLoading(false);
        setFormError("Reseller upgrades require a Reseller ID.");
        return;
      }

      const payload = {
        mechanism: upgradeType,
        reseller_id: resellerId,
        reseller_invoice_number: resellerInvoiceNumber,
      };

      // Remove empty keys from payload object.
      Object.keys(payload).forEach((k) => payload[k] === null && delete payload[k]);

      return superagent
        .post(`${AUTH_API_URL}/licenses/${license._id}/upgrade`)
        .withCredentials()
        .send(payload)
        .end((err) => {
          if (err) {
            setFormError(err);
            setUpgradeLoading(false);
            return;
          }

          setUpgradeLoading(false);
          onUpgradeLicense();
        });
    }
  };

  const handleTypeChange = (_, { value }) => {
    setFormError(null);

    if (value !== UPGRADE_TYPES.RESELLER) {
      setResellerId(null);
      setResellerInvoiceNumber(null);
    }

    setUpgradeType(value);
  };

  const onResellerSelectionChange = (_, selection) => {
    if (selection && selection._id) {
      setResellerId(selection._id);
    }
  }

  return (
    <React.Fragment>
      <Form
        size="tiny"
        loading={upgradeLoading}
      >
        <Form.Group>
          <Dropdown
            placeholder="Upgrade Type"
            onChange={handleTypeChange}
            value={upgradeType}
            selection
            fluid
            options={[
              { key: UPGRADE_TYPES.USER, value: UPGRADE_TYPES.USER, text: "Manual" },
              { key: UPGRADE_TYPES.RESELLER, value: UPGRADE_TYPES.RESELLER, text: "Reseller" },
            ]}
          />
        </Form.Group>
        {upgradeType === UPGRADE_TYPES.RESELLER ? (
          <Form.Group>
            <ResellerSearch
              width={8}
              labelTxt="Reseller:"
              popupTxt="Type to search Resellers. On submit, the upgrade will be applied with the relevant Reseller details."
              placeholder="Type to search Resellers for upgrade..."
              onChange={onResellerSelectionChange}
            />
            <BaseInputField
              width={8}
              name="resellerInvoice"
              type="text"
              value={resellerInvoiceNumber}
              onChange={(e) => setResellerInvoiceNumber(e.target.value)}
              labelTxt="Invoice Number (optional)"
              popupTxt="Set an invoice number for this upgrade. Internal use only."
            />
          </Form.Group>
        ) : null}
        <Form.Group>
          <Button.Group>
            <Button onClick={onCancel}>Cancel</Button>
            <Button.Or />
            <Button positive onClick={handleUpgrade}>Upgrade</Button>
          </Button.Group>
        </Form.Group>
      </Form>
      {formError ? (
        <Message warning header="There was a problem:" content={formError} />
      ) : null}
    </React.Fragment>
  );
};

UpgradeLicense.propTypes = {
  license: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onUpgradeLicense: PropTypes.func.isRequired,
};

export default UpgradeLicense;



// WEBPACK FOOTER //
// ./webAdmin/views/license/upgrade.js